import type { CancelToken } from 'axios';
import type { TaskPriority } from '../async/taskPriority';
import type { Resilience } from '../async/resilience';
import type { BackendClient } from './backendClient';
import type { AdditionalParams } from './apiClient';

export interface ApiContextOptions {
  cancelToken?: CancelToken,
  priority?: TaskPriority,
  beforeRetryInterlude?: (ms: number, cause: any) => void
}


/**
 * Encapsulates the information needed to perform an HTTP API request within the
 * context of a given high-level operation. Each high-level operation should
 * have their own OperationApiContext, since the resilience retry plan maintains
 * state that should be bounded by the high-level operation.
 *
 * I.e. code that is may be called as a part of a high-level operation, but is
 * not a standalone high-level operation in itself, should take an
 * OperationApiContext as a parameter, rather than constructing throw-away
 * instances themselves.
 */
export class OperationApiContext {
  constructor(
    readonly client: BackendClient,
    readonly resilience: Resilience,
    readonly options: ApiContextOptions = {}
  ) {}

  getAdditionalParams(): AdditionalParams {
    return { cancelToken: this.options?.cancelToken, priority: this.options.priority };
  }
}
